import { Component, inject, input, model, output } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { InfoCardLinkComponent } from '../info-card-link/info-card-link.component';
import { UiComponentsModule } from '@mwe/ui/components';
import { InfoCardChevronButtonComponent } from '../info-card-chevron-button/info-card-chevron-button.component';
import { InfoCardType } from '../../../../../model/info-card-type.enum';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lib-ikp-info-card-title',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, InfoCardLinkComponent, UiComponentsModule, InfoCardChevronButtonComponent],
  templateUrl: './info-card-title.component.html',
  styleUrl: './info-card-title.component.scss',
})
export class InfoCardTitleComponent {
  translate = inject(TranslateService);

  readonly infoCardType = input<InfoCardType>();
  readonly title = input<string>();
  readonly truncateTitle = input(true);
  readonly subtitle = input<string>();
  readonly iconPath = input<string>();
  readonly isCheckbox = input<boolean>();
  readonly isChecked = input<boolean>();
  readonly actionText = input<string>();
  readonly actionColor = input<string>();
  readonly actionIcon = input<string>();
  readonly actionButtonCategory = input<'primary' | 'secondary' | 'tertiary'>('primary');
  readonly actionButtonSize = input<'lg' | 'md' | 'sm' | 'xs'>('lg');
  readonly actionButtonDisabled = input<boolean>(false);
  readonly dataTest = input<string>();
  readonly actionClicked = output<void>();
  isCollapsed = model<boolean>();
  index = input<number>();
  lang = this.translate.getDefaultLang();

  onActionClicked() {
    // maybe track action here
    this.actionClicked.emit();
  }

  protected readonly InfoCardType = InfoCardType;
}
